import { Color, ColorFill, Container, SvgGraphics } from '@tencent/alloy-renderer';
import { IWrapperComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/types';
import { InterfaceFactoryOptions } from './factory-options.interface';
import { buildTreeSync } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/slide/build-tree-sync';
import { CANVAS_SMART_ART_ID_PREFIX } from '@src/slide/content-viewer/service/canvas-renderer/core/id-constants';
import { ISmartArtModel } from '@src/slide/domain/ui-model/element-modeles/Interface/smart-art-model.interface';
import { getElementRect } from '@src/framework/editor/src/page/index/components/canvas/element-wrapper/utils';
// import { GroupRefreshMenu } from '@src/slide/domain/ui-model/element-modeles/property/menu-property/refresh/group';

/**
 * SmartArt 模块
 * 直接遍历children，调用factory递归渲染图形
 * 此处MouseDown、MouseUp区别于其他图形，但是应该可以优化统一
 */
export class RendererSmartArtComponent extends Container {
    private readonly factoryOptions: InterfaceFactoryOptions<ISmartArtModel>;
    private needMouseUp;
    private hasDidMount = false;
    // 占位图形
    private rectEventArea: SvgGraphics;

    public constructor(factoryOptions: InterfaceFactoryOptions<ISmartArtModel>) {
        super();
        this.factoryOptions = factoryOptions;
        if (!this.factoryOptions.asyncBuild) {
            this.updateComponent();
        }
        const { model } = this.factoryOptions;
        this.id = `${CANVAS_SMART_ART_ID_PREFIX}-${model.key}`;
    }

    /**
     * 构造子元素需要的factoryOption
     * @param childModel
     */
    public childFactoryOption<M = any>(childModel: M): InterfaceFactoryOptions<M> {
        return {
            ...this.factoryOptions,
            model: childModel,
            isGroupChildren: true,
        };
    }

    public updateComponent = () => {
        // 缩放旋转的过程中，不绘制子元素
        const { editingStateManager } = this.factoryOptions;
        if (editingStateManager?.isRotating || editingStateManager?.isResizing) return;

        // 更新组件时添加空白点击区域
        const rect = getElementRect({ element: this.factoryOptions.model, tableResizing: false, useAdvHas: false });
        const { width, height } = rect;
        const path = `M 0 0 L ${width} 0 L ${width} ${height} L 0 ${height} Z`;
        if (!this.rectEventArea) {
            this.rectEventArea = new SvgGraphics(path);
            this.rectEventArea.fill = new ColorFill(Color.Transparent);
            this.addChild(this.rectEventArea);
        } else {
            this.rectEventArea.path = path;
        }

        buildTreeSync({
            canvasLayer: this,
            canvasArr: this.children as IWrapperComponent[],
            modelsArr: this.factoryOptions.model.shapeList,
            componentFactoryOptions: this.childFactoryOption(null),
            componentNeedUpdate: true,
        });

        if (!this.hasDidMount) {
            this.componentDidMount();
            this.hasDidMount = true;
        }
    };

    private componentDidMount() {
        // const { model } = this.factoryOptions;
        // 更新group的itemValues
        // GroupRefreshMenu.caculateItemValues(model);
    }
}
